import { render, staticRenderFns } from "./MealEditorSaveButton.vue?vue&type=template&id=a3e770ec&"
import script from "./MealEditorSaveButton.vue?vue&type=script&lang=js&"
export * from "./MealEditorSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports